<template>
  <div>

  <!-- basic Game attributes -->
  <v-form class="mt-2" v-model="valid">
    <v-card class="mb-4">
      <v-card-title>Meta</v-card-title>
      <v-card-text>
        <v-select :rules="[rules.required]" label="Locale" v-model="item.locale" :items="locales" item-text="name" item-value="value" />
        <v-text-field :rules="[rules.required]" label="Name" v-model="item.name"></v-text-field>
        <v-textarea :rules="[rules.required]" label="Description" v-model="item.description" rows="4"></v-textarea>
        <v-textarea :rules="[rules.required]" label="Rules" v-model="item.rules" rows="4"></v-textarea>
        <v-textarea :rules="[rules.required]" label="Html Title" v-model="item.htmlTitle" rows="4"></v-textarea>
        <v-textarea :rules="[rules.required]" label="Html Description" v-model="item.htmlDescription" rows="4"></v-textarea>
        <v-combobox :rules="[rules.atLeastOne]" label="Categories" v-model="item.categories"
          :items="categories.filter(c => c.locale === item.locale)" item-text="name" return-object chips multiple>
        </v-combobox>
        <Thumbs v-if="item.id" :game="game" :thumbs="item.thumbs" @change="$emit('change', item)"></Thumbs>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="save()" :disabled="!valid">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
  <!-- / basic Game attributes -->

  </div>
</template>

<script>
import { locales } from '@/constants/locales'
import Thumbs from '../../../components/Thumbs/Thumbs.vue';

export default {
  name: 'MetaForm',
  components: { Thumbs },
  props: {
    parent: {},
    game: {},
    item: {},
  },
  created() {
    this.$gameApi.get('/dictionary/categories').then(categories => this.categories = categories);
  },
  data() {
    return {
      locales,
      categories: [],
      valid: false,
      rules: {
        required: value => !!value || 'Required.',
        atLeastOne: value => value.length > 0 || 'Pick at least one.',
      },
    };
  },
  methods: {
    save() {
      this.$emit('change', this.item);
    }
  }
};
</script>

